import { useMemo } from 'react'
import {
  TransactionFormProvider,
  isTransactionRowFilled,
  type BusinessAssociation,
  useTransactionFormContextCore,
} from './collectingReturningContextCore'

export { isTransactionRowFilled }
export type { BusinessAssociation }

export const CollectingFormProvider = TransactionFormProvider

type CoreContextValue = ReturnType<typeof useTransactionFormContextCore>

type CollectingFormContextValue = Omit<
  CoreContextValue,
  'setTransactionDate'
> & {
  setCollectingDate: CoreContextValue['setTransactionDate']
}

export const useCollectingFormContext = (): CollectingFormContextValue => {
  const context = useTransactionFormContextCore(
    'useCollectingFormContext must be used inside CollectingFormProvider'
  )

  return useMemo(
    () => ({
      ...context,
      setCollectingDate: context.setTransactionDate,
    }),
    [context]
  )
}
